/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { getAuth } from '../../../modules/auth/core/AuthHelpers'

const Revision: React.FC = () => {
  const usuario = getAuth()
  return (
    <>

      <h2>Datos del Pedido</h2>
      <div className="my-3 me-5 pe-5 d-flex justify-content-between">
        <h4>Nombre: <span className='fw-light'>{usuario?.usuarioGc_Track?.nombreCompleto}</span> </h4>
        <h4>Correo: <span className='fw-light'>{usuario?.usuarioGc_Track?.correo}</span></h4>
        <h4>Empresa: <span className='fw-light'>{usuario?.usuarioGc_Track?.organizacion}</span></h4>
      </div>
      <div className="mb-3 me-5 pe-5 d-flex justify-content-between">
        <h4>Ubicación: <span className='fw-light'>Sucursal 1</span></h4>
        <h4>Ciudad: <span className='fw-light'>Mexicali</span></h4>
        <h4>País: <span className='fw-light'>México</span></h4>
        <h4>Dirección: <span className='fw-light'>Hacienda del Río ####</span></h4>
      </div>

      <div className='separator separator-dashed my-6'></div>

      <table className="table table-striped gy-2 gs-2">
        <thead>
          <tr className="fw-bold fs-5 text-gray-800 border-bottom border-gray-800">
            <th className="min-w-50px">SKU</th>
            <th className="min-w-150px">Producto</th>
            <th className="min-w-50px">Cant</th>
            <th className="min-w-50px">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr> <td>132456</td><td>Producto 1</td><td>1</td><td align='right'>$XX.XX</td> </tr>
          <tr> <td>845697</td><td>Producto 2</td><td>3</td><td align='right'>$XX.XX</td> </tr>
          <tr> <td>146846</td><td>Producto 3</td><td>2</td><td align='right'>$XX.XX</td> </tr>
          <tr> <td>142326</td><td>Producto 4</td><td>8</td><td align='right'>$XX.XX</td> </tr>

        </tbody>
        <tfoot>
          <tr className='border-top border-gray-800'> <td></td><td>Subtotal</td><td></td><td align='right'>$XX.XX</td> </tr>
          <tr> <td></td><td>Descuento</td><td></td><td align='right'>-$XX.XX</td> </tr>
        </tfoot>
      </table>

      <div className='card-footer d-flex py-3 px-3 d-flex justify-content-end'>

        <h2 className='col-1'>Total</h2>
        <h2>$XX.XX</h2>

      </div>

    </>

  )
}

export { Revision }
